// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__1hiTj","col":"Table_col__1jjMn","fulfillmentStatus":"Table_fulfillmentStatus__3_Wxp","emailCol":"Table_emailCol__1iYor"};